import { createApiAction } from 'src/utils/helpers';

export const GET_POLYGON_AREAS = 'GET_POLYGON_AREAS';
export const GET_POLYGON_AREAS_SUCCESS = 'GET_POLYGON_AREAS_SUCCESS';
export const GET_POLYGON_AREAS_FAILURE = 'GET_POLYGON_AREAS_FAILURE';

export const GET_POLYGON = 'GET_POLYGON';
export const GET_POLYGON_SUCCESS = 'GET_POLYGON_SUCCESS';
export const GET_POLYGON_FAILURE = 'GET_POLYGON_FAILURE';

export const GET_ALL_POLYGON_METRICS = 'GET_ALL_POLYGON_METRICS';
export const GET_ALL_POLYGON_METRICS_SUCCESS = 'GET_ALL_POLYGON_METRICS_SUCCESS';
export const GET_ALL_POLYGON_METRICS_FAILURE = 'GET_ALL_POLYGON_METRICS_FAILURE';

export const getPolygonAreas = createApiAction(GET_POLYGON_AREAS);
export const getPolygon = createApiAction(GET_POLYGON);
export const getAllPolygonMetrics = createApiAction(GET_ALL_POLYGON_METRICS);
